import { useEffect, useState } from "react";

// Custom hook to interact with localStorage
const useLocalStorage = (key, withJsonParse = false) => {
  // Function to get the initial value from localStorage
  const initialValue = () => {
    if (withJsonParse) return JSON.parse(localStorage.getItem(key) ?? null);
    else return localStorage.getItem(key) ?? null;
  };

  const [value, setValue] = useState(initialValue());

  // Effect to update the value when localStorage changes
  useEffect(() => {
    const onChange = (e) => {
      if (initialValue()) setValue(e.newValue);
      else setValue(null);
    };
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener("storage", onChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  // Effect to set the initial value
  useEffect(() => {
    setValue(initialValue());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Function to update the value in localStorage
  const updateValue = (newValue) => {
    if (withJsonParse)
      window.localStorage.setItem(key, JSON.stringify(newValue));
    else window.localStorage.setItem(key, newValue);

    let event = new Event("storage");
    event.newValue = newValue;
    window.dispatchEvent(event);
  };

  const removeValue = (keys) => {
    if (Array.isArray(keys))
      keys?.forEach((item) => localStorage.removeItem(item));
    else window.localStorage.removeItem(key);
    setValue(null);
  };

  return { value, updateValue, removeValue };
};

export default useLocalStorage;